import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    PakmailService,
    CreatePakmailServiceInput,
    UpdatePakmailServiceInput,
    DeletePakmailServiceInput,
    ModelPakmailServiceFilterInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class PakmailServiceService {
    private amplifyClient = generateClient();
    constructor() {}

    async listPakmailServices(
        filter: ModelPakmailServiceFilterInput = null
    ): Promise<PakmailService[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPakmailServices,
                    variables: {
                        filter
                    }
                })
            ).data.listPakmailServices.items;
            if (data) return data as PakmailService[];
        } catch (error) {
            console.error('Error finding listPakmailServices:', error);
            return null;
        }
    }

    async createPakmailService(
        input: CreatePakmailServiceInput
    ): Promise<PakmailService> {
        try {
            const pakmailService = (
                await this.amplifyClient.graphql({
                    query: mutations.createPakmailService,
                    variables: {
                        input
                    }
                })
            ).data.createPakmailService;
            if (pakmailService) return pakmailService as PakmailService;
        } catch (error) {
            console.error('Error creating pakmailService:', error);
            return null;
        }
    }

    async updatePakmailService(
        input: UpdatePakmailServiceInput
    ): Promise<PakmailService> {
        try {
            const pakmailService = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePakmailService,
                    variables: {
                        input
                    }
                })
            ).data.updatePakmailService;
            if (pakmailService) return pakmailService as PakmailService;
        } catch (error) {
            console.error('Error creating pakmailService:', error);
            return null;
        }
    }

    async deletePakmailService(
        input: DeletePakmailServiceInput
    ): Promise<PakmailService> {
        try {
            const pakmailService = (
                await this.amplifyClient.graphql({
                    query: mutations.deletePakmailService,
                    variables: {
                        input
                    }
                })
            ).data.deletePakmailService;
            if (pakmailService) return pakmailService as PakmailService;
        } catch (error) {
            console.error('Error deleting pakmailService:', error);
            return null;
        }
    }
}
